import { createAction } from '@wix/communities-blog-client-common';

export const BI_POST_SCROLLED = 'bi/POST_SCROLLED';
export const biPostScrolled = createAction(BI_POST_SCROLLED);

export const BI_ACTIVE_TAB_CHANGED = 'bi/ACTIVE_TAB_CHANGED';
export const biActiveTabChanged = createAction(BI_ACTIVE_TAB_CHANGED);
